<div class="container">

  <form class="likes-form" [formGroup]="engagementFormGroup">

    <mat-form-field appearance="outline" class="post-url compact-form">
      <mat-label>קישור לפוסט</mat-label>
      <input matInput formControlName="postUrl" (blur)="onPostUrlBlur()" />

      @if (engagementFormGroup.get('postUrl')?.hasError('required')) {
        <mat-error>
          שדה חובה
        </mat-error>
      }

      @if (engagementFormGroup.get('postUrl')?.hasError('pattern')) {
        <mat-error>
          פורמט קישור לא תקין
        </mat-error>
      }
    </mat-form-field>

    <div class="row-container">

      <mat-form-field appearance="outline" class="number-of-likes compact-form">
        <mat-label>מספר לייקים</mat-label>
        <input matInput type="number" inputmode="numeric"  formControlName="numberOfLikes" (keypress)="onlyNumbers($event)" />
        <mat-error>
          שדה חובה
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="seconds-between-likes compact-form">
        <mat-label>שניות בין לייקים</mat-label>
        <input matInput type="number" inputmode="numeric" formControlName="secondsBetweenLikes" (keypress)="onlyNumbers($event)" />
        <mat-error>
          שדה חובה
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="date-picker-field compact-form">
        <mat-label>בחר תאריך</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="startDate">
        <mat-hint>DD.MM.YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="time-picker-field compact-form">
        <mat-label>שעה</mat-label>
        <input matInput type="time" formControlName="startTime">
      </mat-form-field>

    </div>

    @if (engagementFormGroup.hasError('avatarCountError')) {
      <mat-error>שגיאה בבדיקת מספר אוואטרים</mat-error>
    }
    @if (engagementFormGroup.hasError('insufficientAvatars') && engagementFormGroup.get('postUrl')?.touched) {
      <mat-error>
        שגיאה: ישנם רק {{ engagementFormGroup.errors?.['insufficientAvatars'].available }} אווטארים בקבוצה/אזור ,
        אך דרושים {{ engagementFormGroup.errors?.['insufficientAvatars'].required }} עבור הלייקים
      </mat-error>
    }

    @if (isFacebook) {
      <!-- wrap the observable result in an object to get a truthy response even when the emttted value is 0 -->
      @if ({ val: (countAvatarsInGroup$ | async) }; as data) {
        @if (data.val !== null && !engagementFormGroup.errors) {
          @if(engagementFormGroup.get('resourceType')?.value == 'group'){
            <div class="avatar-info">
              מספר הלייקים מוגבל ל- {{ data.val }} בהתאם למספר האווטארים בקבוצה זו
            </div>
          }
          @if(engagementFormGroup.get('resourceType')?.value == 'page'){
            <div class="avatar-info">
              מספר הלייקים מוגבל ל- {{ data.val }} בהתאם למספר האווטארים באזור
            </div>
          }
        }
      }
    }

    @if (engagementFormGroup.pending) {
      <span>בודק חוקיות נתונים..</span>
    }

    @if (isFacebook) {
      @if (engagementFormGroup.hasError('groupRegionMismatch') && engagementFormGroup.get('postUrl')?.touched) {
        <mat-error>
          שגיאה: הקבוצה אינה משוייכת לאזור שנבחר
        </mat-error>
      }
    }

    <!-- <pre>engagementFormGroup.errors: {{ engagementFormGroup.errors | json }}</pre>         -->

  </form>


</div>